import React from "react";

import {
  IonContent, IonIcon,
} from "@ionic/react";

import { RouteComponentProps } from "react-router";
import { AppPage } from "../AppContent";
import { LogsCard } from "../components/debug/logs-card";
import { useLogs } from "../services/LogService";
import { chevronBackOutline } from "ionicons/icons";
import { FormattedMessage } from "react-intl";

interface LogsPageProps extends RouteComponentProps { }

const LogsPage: React.FC<LogsPageProps> = ({ history }) => {

  const logs = useLogs();

  return (
    <AppPage>
      <IonContent className="p-0 scrollable">
        <button className="hidden text-sm items-center font-bold text-primary mb-8 md:flex"
          onClick={history.goBack}>
          <IonIcon className="text-primary mr-2" icon={chevronBackOutline} />
          <FormattedMessage id="Go back" />
        </button>

        <LogsCard logs={logs} />

      </IonContent>

    </AppPage>
  );
};

export default LogsPage;
